import { Box, Container, Flex, Group, Loader, Skeleton, Stack, Center } from "@mantine/core";
import { CONTENT_MAX_WIDTH } from "@/shared/constants/layout.constants";

function TopNavSkeleton() {
  return (
    <Box
      component="header"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 50,
        background: "#ffffff",
        borderBottom: "1px solid #e4e8ee",
      }}
    >
      <Flex
        align="center"
        justify="space-between"
        style={{ height: 80, maxWidth: CONTENT_MAX_WIDTH, margin: "0 auto", padding: "0 20px", gap: 12 }}
      >
        <Skeleton height={28} width={140} radius="sm" />

        <Group visibleFrom="sm" gap={16} wrap="nowrap" style={{ flex: 1, justifyContent: "center" }}>
          <Skeleton height={14} width={130} radius="xl" />
          <Skeleton height={14} width={90} radius="xl" />
          <Skeleton height={14} width={80} radius="xl" />
          <Skeleton height={14} width={70} radius="xl" />
          <Skeleton height={14} width={75} radius="xl" />
        </Group>

        <Group gap={10} wrap="nowrap">
          <Skeleton height={34} width={92} radius="xl" />
          <Skeleton height={34} width={92} radius="xl" />
        </Group>
      </Flex>
    </Box>
  );
}

function DiscoverBodySkeleton() {
  return (
    <Container size={CONTENT_MAX_WIDTH} style={{ paddingTop: 110, paddingBottom: 32 }}>
      <Stack gap="xl">
        <Stack gap={10}>
          <Skeleton height={26} radius="sm" width={320} />
          <Skeleton height={14} radius="sm" width={520} />
        </Stack>

        <Group wrap="nowrap" gap="sm" align="center">
          <Skeleton height={44} radius="xl" style={{ flex: 1 }} />
          <Skeleton height={44} width={120} radius="xl" visibleFrom="sm" />
          <Skeleton height={44} width={120} radius="xl" visibleFrom="sm" />
        </Group>

        <Flex gap="lg" align="flex-start">
          {/* Main results */}
          <Box style={{ flex: 1, minWidth: 0 }}>
            <Flex wrap="wrap" gap="md">
              {Array.from({ length: 8 }).map((_, i) => (
                <Skeleton key={i} height={148} radius="md" style={{ flex: "1 1 360px", minWidth: 300 }} />
              ))}
            </Flex>
          </Box>

          {/* Desktop promo/aside */}
          <Box visibleFrom="lg" style={{ width: 340 }}>
            <Skeleton height={420} radius="md" />
          </Box>
        </Flex>
      </Stack>
    </Container>
  );
}

/**
 * Lightweight fallback while a lazy child route loads inside AppShell (sidebar stays visible).
 */
export function AppShellRouteFallback() {
  return (
    <Center mih="50vh">
      <Loader color="primary" />
    </Center>
  );
}

/**
 * Suspense fallback meant to mimic the `/` discover experience:
 * fixed header + search + result cards, so users see stable UI while route chunks load.
 */
export function RouteFallback() {
  return (
    <Box style={{ minHeight: "100vh", background: "#ffffff" }}>
      <TopNavSkeleton />
      <DiscoverBodySkeleton />
    </Box>
  );
}

